export { default } from "./ActivityDetail";
